export default {"src":"/_next/static/media/minillus-question.0f7ef7af.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};